// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4LdhM","section":"styles_section__ygzqr","divider":"styles_divider__h6mYP","text":"styles_text__NMXja","label":"styles_label__dzqyP"};